<template>
  <section class="nylon-ShopFeature" :class="[type, color, background]" data-header-hero>
    <div class="background"></div>

    <slot name="header"></slot>

    <div :class="wrapperClass" ref="autoScrollWrapper">
      <slot name="prepend"></slot>
      <transition-group name="billboard-item">
        <slot v-for="item in items" :key="item.id" name="item" :item="item"></slot>
      </transition-group>
      <slot name="append"></slot>
    </div>
  </section>
</template>

<script>
import AutoScrollStrip from "@/mixins/auto-scroll-strip.js";

export default {
  mixins: [AutoScrollStrip],

  props: {
    type: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
    background: {
      type: String,
      required: true,
    },
    wrapperClass: {
      type: String,
      required: false,
      default: "",
    },
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    // Opt in to the shared idle auto-scroll drift (billboards strip). Off by
    // default so takeover/deck and other uses are unaffected.
    autoScroll: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  methods: {
    // AutoScrollStrip contract — only animate when opted in; the wrapper is the
    // horizontal scroll container (overflow-x: scroll on `.billboard-wrapper`).
    autoScrollViewport() {
      return this.autoScroll ? this.$refs.autoScrollWrapper : null;
    },
  },
};
</script>
